import React, { useEffect, useState } from "react";
import "../popularProducts/popularproducts.css";
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import StarIcon from '@mui/icons-material/Star';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { baseURL } from "../../constants/url";

const PopularProducts = ({ subcategoryId }) => {
  const { id } = useParams(); // Subcategory ID
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await axios.get(`${baseURL}?subcategory_id=${subcategoryId}`);
        setProducts(res.data || []);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    if (id) {
      fetchProducts();
    }
  }, [id]);

  return (
    <>
      <div className="container-fluid pop_pro_title">
        <div className="row">
          <div className="col-lg-12 mt_15">
            <div className="heading_common mt_15">
              <h3>Popular Products ({products.length})</h3>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="popular_products">
              <div className="popular_products_grid">

                {products.length > 0 ? (
                  products.map((product, index) => (
                    <div className="popular_products_grid_in" key={product.id || index}>
                      <div className="products_head d_flex align_center justify_sp_between">
                        <div><span className="sale_type font_size14">Hot</span></div>
                        <div className="whislist_icon_box">
                          <Link to="#" className="whislist_icons"><FavoriteBorderIcon /></Link>
                          <Link to="#" className="add_to_cart_icons font_size14"><AddShoppingCartIcon /></Link>
                        </div>
                      </div>

                      <div className="products_details">
                        <div className="products_img d_flex align_center">
                          <Link to="#">
                          <img src={product.images && product.images.length > 0 ? product.images[0].image : "https://via.placeholder.com/150"}
                        alt={product.name}
                        className="img-fluid"
                        />
                          </Link>
                        </div>

                        <div className="products_info">
                          <div className="products_name mt_5">
                            <Link to="#">{product.name}</Link>
                          </div>
                          <div className="pro_price mt_10 d_flex gap_10 align_center">
                            <h6>₹{product.price}/</h6>
                            {product.original_price && (
                              <h6 className="price_cut"><s>₹{product.original_price}</s>/</h6>
                            )}
                            {product.discount_percentage && (
                              <h6 className="common_color">({product.discount_percentage}% Off)</h6>
                            )}
                          </div>
                          <div className="rating_part d_flex gap_5 align_center">
                            <span>{product.rating || "4.0"}</span>
                            <StarIcon />
                          </div>
                        </div>
                      </div>

                      <div className="products_footer mb_20 d_flex align_center justify_sp_center">
                        <div><Link to="#" className="buy_btn font_size14">Buy Now</Link></div>
                      </div>
                    </div>
                  ))
                ) : (
                  <p>No products available for this subcategory.</p>
                )}

              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PopularProducts;
